function reviews_tabs()
{
    // Link in links tops row
    const link = document.querySelector('.links-top .woocommerce-review-link');
    // Button in tab
    const btn = document.querySelector('#reviews .average-reviews button');
    // Wrapper
    const formWrapper = document.getElementById('review_form_wrapper');

    const displayTab = function() {
        document.querySelectorAll('.woocommerce-tabs > ul > li').forEach(tab => {
            tab.classList.remove('active');
        });

        document.querySelector('a[href="#tab-m-reviews"]').click();
    }

    const displayForm = function() {
        formWrapper.classList.remove('hide');

        // Scroll to node - header offset.
        const top = formWrapper.getBoundingClientRect().top;
        const offset = document.querySelector('header.site-header').getBoundingClientRect().height;

        window.scrollBy(0, top - offset);
    }

    if (link) {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            displayTab();
            displayForm();
        });
    }

    if (btn) {
        btn.addEventListener('click', displayForm);
    }
}



export { reviews_tabs };
